module.exports = "<app-search-account (accSelected)=\"setAccount($event)\"></app-search-account>"


//////////////////
// WEBPACK FOOTER
// ./src/app/link-device-to-member-dialog/link-device-to-member-dialog.component.html
// module id = ./src/app/link-device-to-member-dialog/link-device-to-member-dialog.component.html
// module chunks = main